import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import zh from './locales/zh.json';

const i18n = createI18n({
  locale: 'zh',  // 默认语言
  fallbackLocale: 'zh',  // 回退语言
  messages: {
    zh,
    en,
  },
});

export default i18n;
